import React from 'react';
import moment from 'moment';
import Avatar from "assets/icons/Avatar.svg";

interface WithPerPageProps {
  studentsData: any;
  authData: any;
  sizeScale: number;
  schoolNameAlignment: string;
  examNameAlignment: string;
  sortedSubjects: any[];
  cardHeight: number;
  perPage: number;
  hasSubjectType: boolean
}

const WithPerPage: React.FC<WithPerPageProps> = ({
  studentsData,
  authData,
  sizeScale,
  schoolNameAlignment,
  examNameAlignment,
  sortedSubjects,
  cardHeight,
  perPage,
  hasSubjectType
}) => {

  return (
    <div className={`w-full grid grid-cols-1 gap-6 p-0 m-0 box-border mx-auto container-ht`}> 

    {studentsData?.Students?.map((object, objectIndex) => {
      const headingSize = Math.round(sizeScale * 2.2)
      const subHeadingSize = Math.round(sizeScale * 2)
      const paragraphSize = Math.round(sizeScale * 1.6)
      const margin = Math.round(sizeScale * 1);

      return (
        <div key={objectIndex}
        className="card w-full p-0 border"
        style={{
          breakInside: "avoid",
          pageBreakInside: "avoid",
          overflow: "hidden",
          width: `100%`,
          backgroundColor:'white',
          boxShadow: 'none',
          padding: 0,
          margin: 0
        }}
        >
        <div className='border border-gray-500' >
          {studentsData?.HallTicketSettings?.SHOW_HEADER && (
            <div className={`flex items-center gap-2 px-1 ${schoolNameAlignment === 'style1' ? `relative` : schoolNameAlignment === 'style2' ? 'justify-center' : ''}`} 
              style={{
                marginTop: `${Math.round(sizeScale)}px`,
                marginBottom: `${Math.round(sizeScale)}px`,
              }}
              >
              {studentsData?.HallTicketSettings?.SHOW_HEADER_SCHOOL_LOGO && (
                <img
                  src={authData?.BRANCH_LOGO || Avatar}
                  style={{
                    width: (sizeScale * 6)+"px",
                    height: (sizeScale * 6)+"px"
                  }}
                  alt="school-logo"
                  className="object-cover rounded-full "

                />)}
              <div 
               className={`flex flex-col ${schoolNameAlignment !== `style2` && `flex-1`} ${schoolNameAlignment === 'style1' && `text-center items-center`}`}
              >
                {studentsData?.HallTicketSettings?.SHOW_HEADER_SCHOOL_NAME && (
                  <h1 className={`font-bold text-black ${['style1', 'style2']?.includes(schoolNameAlignment) && `text-center`}`}
                    style={{ fontSize: `${headingSize}px` }}
                  >
                    {authData?.BRANCH_NAME}
                    {/* SOOMUCH DEMO BRANCH 1 SOOMUCH DEMO BRANCH 1 SOOMUCH DEMO BRANCH 1 SOOMUCH DEMO BRANCH 1 SOOMUCH DEMO BRANCH 1 */}
                  </h1>
                )}

                {studentsData?.HallTicketSettings?.SHOW_HEADER_SCHOOL_ADDRESS && (
                  <p className={`font-bold mr-4 ${['style1', 'style2']?.includes(schoolNameAlignment) ? `text-center` : ''}`}
                    style={{ fontSize: `${subHeadingSize}px` }}
                  >{authData?.BRANCH_ADDRESS}</p>
                )}
              </div>
            </div>)}
          <hr />

          {/* Exam Name */}
            <div className={`flex ml-9 ${examNameAlignment === 'center' ? 'justify-center' : 'justify-start'}`} 
            style={{
              marginTop: `${Math.round(sizeScale)}px`,
              marginBottom: `${Math.round(sizeScale)}px`,
            }}
            >
              <h1 className="font-bold text-black" style={{ fontSize: `${subHeadingSize}px` }}>
                {studentsData?.Exam} Hall Ticket
              </h1>
            </div>
            
            <hr />

            {studentsData?.HallTicketSettings?.SHOW_STUDENT && (
              <div className={`w-full flex items-center px-2% gap-4`} style={{marginTop: `${margin}px`, marginBottom: `${margin}px`}} >
              <div className="w-full flex items-center justify-around gap-4">
                  <div className="flex flex-col">
                    <div className='flex items-center gap-3'>
                      {studentsData?.HallTicketSettings?.SHOW_STUDENT_PHOTO && (
                        <div className={`border border-black rounded-full overflow-hidden`} style={{width: `${paragraphSize * 3}px`, height: `${paragraphSize * 3}px`}} >
                          <img
                            src={object?.PhotoUrl || Avatar}
                            alt="student-profile"
                            className="w-full h-full object-cover"
                          />
                        </div>
                      )}
                      <div className='flex flex-col'>
                        <span className="font-bold" style={{ fontSize: `${paragraphSize}px` }}>{object.StudentName}</span>
                        <span className="text-[#0000004D]" style={{ fontSize: `${paragraphSize}px` }}>Roll No:{object?.RollNo || ''}</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <span className='font-bold' style={{ fontSize: `${paragraphSize}px` }}>{studentsData?.Class || ''}</span>
                    <span className="text-[#0000004D]" style={{ fontSize: `${paragraphSize}px` }}>Class</span>
                  </div>
                 {studentsData?.HallTicketSettings?.SHOW_STUDENT_ADMISSION_NUMBER && <div className="flex flex-col">
                    <span className='font-bold' style={{ fontSize: `${paragraphSize}px` }}>{object?.AdmissionNo || "-"}</span>
                    <span className="text-[#0000004D]" style={{ fontSize: `${paragraphSize}px` }}>Admission No</span>
                  </div>}
                  <div className="flex flex-col">
                    <span className="font-bold" style={{ fontSize: `${paragraphSize}px` }}>{object?.FatherName || "-"}</span>
                    <span className="font-normal text-[#0000004D]" style={{ fontSize: `${paragraphSize}px` }}>Father Name</span>
                  </div>
                  {studentsData?.HallTicketSettings?.SHOW_MOBILE_NUMBER && (
                  <div className="flex flex-col">
                    <span className="font-bold" style={{ fontSize: `${paragraphSize}px` }}>{object?.ParentMobileNo || '-'}</span>
                    <span className="font-normal text-[#0000004D]" style={{ fontSize: `${paragraphSize}px` }}>Mobile No</span>
                  </div>
                  )}
                </div>
              </div>
            )}

            <div className='px-3'>
              {!!(studentsData?.HallTicketSettings?.SHOW_EXAM_SUBJECT || studentsData?.HallTicketSettings?.SHOW_COSCHOLASTIC_SUBJECT || studentsData?.HallTicketSettings?.SHOW_ADDITIONAL_SUBJECT) && (
                <table className={`tableContainer w-full`}>
                  <thead>
                    <tr className=''>
                      <th className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>Subject Name</th>
                      <th className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>Exam Date</th>
                      {studentsData?.HallTicketSettings?.SHOW_EXAM_SUBJECT_START_TIME && (
                        <th className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>Start Time</th>
                      )}
                      {studentsData?.HallTicketSettings?.SHOW_EXAM_SUBJECT_END_TIME && (
                        <th className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>End Time</th>
                      )}
                      {studentsData?.HallTicketSettings?.SHOW_EXAM_SUBJECT_STAFF_SIGNATURE && (
                        <th className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>Invigilator Signature</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {sortedSubjects?.map((subject, subjectIndex) => {
                      const examStartDate = moment(subject.ExamStartDatetime);
                      const examEndDate = moment(subject.ExamEndDatetime);
                      const startTime = examStartDate.format('hh:mm A');
                      const endTime = examEndDate.format('hh:mm A');

                      const showGeneral = studentsData?.HallTicketSettings?.SHOW_EXAM_SUBJECT;
                      const showCoscholastic = studentsData?.HallTicketSettings?.SHOW_COSCHOLASTIC_SUBJECT;
                      const showAdditional = studentsData?.HallTicketSettings?.SHOW_ADDITIONAL_SUBJECT;

                      return (
                        <tr key={subjectIndex} className=''>

                          {/* <td className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>
                            {subject.SubjectName}
                            {subject.SubjectType !== "General" && ` (${subject.SubjectType})`}
                          </td> */}

                          {showGeneral && ['Regular', 'General']?.includes(subject.SubjectType) && (
                            <td className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>{subject.SubjectName}</td>
                          )  }
                          {showCoscholastic && subject.SubjectType == "Coscholastic" && (
                            <td className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>{subject.SubjectName}{(subject?.SubjectType !== "General" && hasSubjectType) ? ` - (${subject?.SubjectType})` : ''}</td>
                          )}
                          {showAdditional && subject.SubjectType == 'Additional' && (
                            <td className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>{subject.SubjectName}{(subject?.SubjectType !== "General" && hasSubjectType) ? ` - (${subject?.SubjectType})` : ''}</td>
                          )}
                          {showAdditional && subject.SubjectType == 'Optional' && (
                            <td className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>{subject.SubjectName}{(subject?.SubjectType !== "General" && hasSubjectType) ? ` - (${subject?.SubjectType})` : ''}</td>
                          )}

                          <td className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>{examStartDate.format('DD-MM-YYYY')}</td>
                          {studentsData?.HallTicketSettings?.SHOW_EXAM_SUBJECT_START_TIME && (
                            <td className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>{startTime}</td>
                          )}
                          {studentsData?.HallTicketSettings?.SHOW_EXAM_SUBJECT_END_TIME && (
                            <td className={`p-[${Math.round(sizeScale / 2)}px]`} style={{ fontSize: `${paragraphSize}px` }}>{endTime}</td>
                          )}
                          {studentsData?.HallTicketSettings?.SHOW_EXAM_SUBJECT_STAFF_SIGNATURE && (
                            <td className={`p-[${Math.round(sizeScale / 2)}px]`}>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>

            {studentsData?.HallTicketSettings?.SHOW_SIGNATURE && (
              <div className={`flex justify-between items-center px-6`}>
                {studentsData?.HallTicketSettings?.SHOW_SIGNATURE_CLASS_TEACHER && (
                  <div className='text-center'>
                    <div className={`max-w-[7rem]  ${sizeScale >= 8 ? `h-[3rem]` : `h-[2.5rem]`}`}></div>
                    <div className='border-t mb-1 min-w-[7rem] border-black'></div>
                    <span className='font-semibold' style={{ fontSize: `${paragraphSize}px` }}>Class Teacher</span>
                  </div>
                )}
                {studentsData?.HallTicketSettings?.SHOW_SIGNATURE_PARENT && (
                  <div className='text-center'>
                    <div className={`max-w-[7rem]  ${sizeScale >= 8 ? `h-[3rem]` : `h-[2.5rem]`}`}></div>
                    <div className='border-t mb-1 min-w-[7rem] border-black'></div>
                    <span className='font-semibold' style={{ fontSize: `${paragraphSize}px` }}>Parent</span>
                  </div>
                )}

                {studentsData?.HallTicketSettings?.SHOW_SIGNATURE_PRINCIPAL && (
                    <div className="text-center">
                    <div className={`max-w-[7rem]  ${sizeScale >= 8 ? `h-[3rem]` : `h-[2.5rem]`}`}>
                      {authData?.PRINCIPAL_SIGN && (
                      <img src={authData?.PRINCIPAL_SIGN} className="w-full h-full object-cover" />
                      )}
                    </div>
                    <div className="border-t mb-1 min-w-[7rem] border-black font-semibold"></div>
                    <span className='font-semibold' style={{ fontSize: `${paragraphSize}px` }}>Principal</span>
                    </div>
                  )}

              </div>
            )}

        </div>
        </div>

      )
    })}

     <style> {`
     .tableContainer thead tr, .tableContainer thead tr th, .tableContainer tbody tr td{
        border : 1px solid black;
        border-collapse: collapse;
      }
      .tableContainer thead tr th, .tableContainer tbody tr td{
        text-align: center
      }
      @media print {
      @page {
        size: A4;
        margin: 0;
      }
      .container-ht {
        padding-top: 10px;
        grid-auto-rows: ${cardHeight}px; 
      }
      /* Force a page break after every ${perPage} cards */
      .card:nth-of-type(${perPage}n) {
        page-break-after: always;
      }
      .card:last-of-type {
        page-break-after: avoid;
        
      }
      body {
        zoom: 100%;
        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      }`} </style>

</div>
  );
};

export default WithPerPage;
